import { BoxProps } from "./Box.types";

export const absoluteFillProps: Partial<BoxProps> = {
  position: 'absolute',
  top: 'space-0',
  left: 'space-0',
  width: '100%',
  height: '100%',
};

export const centerContentProps: Partial<BoxProps> = {
  alignItems: 'center',
  justifyContent: 'center',
};
